import axios from "axios";
import {toaster} from "evergreen-ui";
import {hostWithPrefix} from "../common/ApiCommon";


export function getCodesByStation(stationId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/codes',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getTypesByStationAndMeteoCode(stationId, codeId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/codes/' + codeId + "/types",
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getDatasourceTypesByStation(stationId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/datasource_types',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getDatasourcesByStation(stationId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/datasources',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getEntitiesByStation(stationId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/entities/',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getEntitiesByStationAndDatasourceTypeId(stationId, datasourceTypeId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/'
            + stationId + '/datasource_types/'
            + datasourceTypeId + '/entities/',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getCodesIntersectionByStationAndDatasourceTypes(stationId, dt1, dt2) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/codes/intersection?stationId=' + stationId + '&dt1=' + dt1 + "&dt2=" + dt2,
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getDatasourcesByStationAndDatasourceType(stationId, dtId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/datasource_types/' + dtId + '/datasources',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getCodesByStationAndDatasourceType(stationId, dtId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/stations/' + stationId + '/datasource_types/' + dtId + '/codes',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function getCodesByDatasource(datasourceId) {
    return axios({
        url: 'http://' + hostWithPrefix + '/constructor/filters/datasources/' + datasourceId + '/codes/',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
        }
    });
}

export function generateExcelViaTemplateId(templateId, period, name) {
    console.log(templateId)
    const req = {
        name: name,
        period: period
    }

    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/template/' + templateId + "/new", //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    })
}

export function generateExcelViaTemplateIdForRiverFlood(templateId, period, meltingPeriod, name) {
    const req = {
        name: name,
        snowMeltingPeriod: meltingPeriod,
        period: period
    }

    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/template/' + templateId + "/new", //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    })
}

export function generateExcel(period, constructorData, name) {
    const template = {
        station: constructorData.station.id,
        type: 'DECADE',
        stationName: constructorData.station.name,
        decadeOperations: constructorData.decadeOperations.map(operation => operation.code),
        tableOperations: constructorData.tableOperations.map(operation => operation.code),
        duplicationType: constructorData.duplicationType === "NONE" ? "DATASOURCE_TYPE" : constructorData.duplicationType,
        multiplyDimension: constructorData.multiplyDimension,
        withoutDays: constructorData.withoutDays,
        filters: constructorData.filtersRows.map((row) => {
            return {
                type: {
                    id: row.type.id,
                    name: row.type.name
                },
                stnEntity: {
                    id: row.stnEntity.id,
                    name: row.stnEntity.name,
                    valueParamsString: row.stnEntity.valueParamsString
                },
                code: row.code,
                operation: row.operation
            }
        })
    }

    const req = {
        name: name,
        period: period,
        template: template
    }

    return axios({
        url: 'http://' + hostWithPrefix + '/api/outputforms/decade', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    });
}

export function generateExcelByTemplateId(period, id) {
    let today = new Date();
    let dd = String(today.getDate()).padStart(2, '0');
    let mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    let yyyy = today.getFullYear();

    today = dd + '' + mm + '' + yyyy;
    const req = {
        start: period.start,
        end: period.end
    }

    axios({
        url: 'http://' + hostWithPrefix + 'dcpc/api/excel/decade/template/' + id, //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
        responseType: 'blob', // important
    }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'СДМз_name_' + today + '.xls'); //or any other extension
        document.body.appendChild(link);
        link.click();
        toaster.success('Успешно создали!')
    });
}

export function saveTemplate(constructorData, saveFilter, templateName) {
    const req = {
        station: constructorData.station.id,
        type: constructorData.type,
        name: templateName,
        decadeOperations: constructorData.decadeOperations.map(operation => operation.code),
        tableOperations: constructorData.tableOperations.map(operation => operation.code),
        duplicationType: constructorData.duplicationType === "NONE" ? "DATASOURCE_TYPE" : constructorData.duplicationType,
        multiplyDimension: constructorData.multiplyDimension,
        withoutDays: constructorData.withoutDays,
        filters: constructorData.filtersRows.map((row) => {
            return {
                type: {
                    id: row.type.id,
                    name: row.type.name
                },
                stnEntity: {
                    id: row.stnEntity == null? -1: row.stnEntity.id,
                    name:  row.stnEntity == null? "": row.stnEntity.name,
                    valueParamsString: row.stnEntity == null? "" : row.stnEntity.valueParamsString
                },
                code: row.code,
                operation: row.operation
            }
        })
    }

    axios({
        url: 'http://' + hostWithPrefix + '/templates/decade', //your url
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        data: JSON.stringify(req),
    }).then((response) => {
        toaster.success('Шаблон сохранён!')
    }).catch((err) => {
        if (err.response.status === 400) {
            toaster.danger("Некорректный запрос! Возможно шаблон с таким именем уже существует.")
        } else {
            toaster.danger("Не получилось!")
        }
    });

    // saveFilter(req)
    //     .unwrap()
    //     .then(() => {
    //         toaster.success('Успешно!')
    //     })
    //     .catch((err) => {
    //         if (err.status === 400) {
    //             toaster.danger("Некорректный запрос! Возможно шаблон с таким именем уже существует.")
    //         } else {
    //             toaster.danger("Не получилось!")
    //         }
    //     })
}